import { FC } from "react";
import { getUserRoleTitle } from "./helpers";
import { UserRole } from "../types";

export const GLOBAL_USER_STYLES =
  "bg-stone-100 hover:bg-stone-200 dark:bg-stone-900 hover:dark:bg-stone-800";

export const COMPANY_USER_STYLES =
  "bg-stone-100 hover:bg-stone-200 dark:bg-stone-700 hover:dark:bg-stone-600";

export const GENERAL_USER_BADGE_STYLE =
  "badge inline-flex dark:text-white text-stone-900 items-baseline rounded-md px-2.5 py-1 text-xs font-medium leading-5 mr-2";

const userRoleColors: Record<UserRole, string> = {
  Admin: GLOBAL_USER_STYLES,
  "Global Owner": GLOBAL_USER_STYLES,
  "Global Editor": GLOBAL_USER_STYLES,
  "Global Viewer": GLOBAL_USER_STYLES,
  companyOwner: COMPANY_USER_STYLES,
  companyEditor: COMPANY_USER_STYLES,
  companyViewer: COMPANY_USER_STYLES,
};

type UserRoleBadgeProps = {
  type: UserRole;
};

export const UserRoleBadge: FC<React.PropsWithChildren<UserRoleBadgeProps>> = ({
  type,
}: UserRoleBadgeProps) => {
  const colors = userRoleColors[type];

  return (
    <span className={`${GENERAL_USER_BADGE_STYLE} ${colors}`} key={type}>
      {getUserRoleTitle(type)}
    </span>
  );
};
